import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
import { BizLineDesc, MilestoneStatusText } from '../../types/rewardRecords';
import Icon from '@max/leez-icon';
import Button from '@hfe/max-button';
import Image from '@hfe/max-image';
import { formatTimestamp } from '../../utils/time';
import { fenToYuan } from '../../utils/price';
import { parseFreeOrderCardExtra } from '../../utils/rewardRecords';
import { getPriceFontFamily } from '../../utils/style';
import LinearGradient from '@hfe/max-linear-gradient';
const priceFontFamily = getPriceFontFamily();
function FreeOrderMainCard(props) {
    const { rewardItem, onUseClick, noticeItems, cityExploreViewModel, feConfig } = props;
    const { styleConfig, haveCardUnusedConfig } = feConfig ?? {};
    const freeOrderInfo = parseFreeOrderCardExtra(rewardItem) ?? {};
    const bindBizName = freeOrderInfo?.bindOrderId && freeOrderInfo.bindBizLine ? BizLineDesc?.[freeOrderInfo?.bindBizLine] : '';
    // 城市信息从 selectedCardGroups[0] 取
    const cityInfo = freeOrderInfo?.selectedCardGroups?.[0];
    const displayCityName = cityInfo?.cityName ?? '';
    // 有效期使用 FreeOrderCardExtra.useEndTime（免单卡使用截止时间），而非活动结束时间
    const endTimeStamp = formatTimestamp(freeOrderInfo?.useEndTime, 'chinese');
    const yuanPrice = fenToYuan(freeOrderInfo.amount);
    // R002：可绑定业务线枚举值列表，通过 BizLineDesc 映射为展示名称
    const canBindBizLineNames = (freeOrderInfo?.canBindBizLines ?? []).map(line => BizLineDesc[line] ?? String(line));
    // R002：标题文案
    const titleText = haveCardUnusedConfig?.titleText ?? '获得城市住行玩免单卡 最高可减';
    // R002：「先到先得」角标文案
    const badgeText = haveCardUnusedConfig?.badgeText ?? '先到先得';
    return <>
      <View x-if={!freeOrderInfo?.bindOrderId} style={{
        backgroundColor: styleConfig?.backgroundColor
    }} className="unused-free-order-main-card__container">
        <LinearGradient colors={[styleConfig?.cardStartColor, styleConfig?.cardEndColor]} className="unused-free-order-main-card__background"/>
        <View className="unused-free-order-main-card__wrapper">
          
          <View className="unused-free-order-main-card__title-wrapper">
            <Text className="unused-free-order-main-card__title-text">{titleText}</Text>
          </View>
          
          <View className="unused-free-order-main-card__amount-wrapper">
            <Text className="unused-free-order-main-card__amount-prefix" style={{
        fontFamily: priceFontFamily
    }}>
              ¥
            </Text>
            <Text className="unused-free-order-main-card__amount-content" style={{
        fontFamily: priceFontFamily
    }}>
              {yuanPrice}
            </Text>
          </View>
          
          <View x-if={canBindBizLineNames.length > 0} className="unused-free-order-main-card__biz-line-wrapper">
            <Text className="unused-free-order-main-card__biz-line-text">
              可核销{displayCityName ? `${displayCityName}-` : ''}
              {canBindBizLineNames.join('、')}等订单
            </Text>
            <Button className="unused-free-order-main-card__biz-line-icon" style={{
        marginLeft: '4rpx'
    }} onPress={props.onOpenBindingRule}>
              <Icon name="wenhao" className="unused-free-order-main-card__biz-line-icon"/>
            </Button>
          </View>
          
          <View className="unused-free-order-main-card__btn-wrapper">
            <Button className="unused-free-order-main-card__use-button" onPress={() => onUseClick({
        cityInfo
    })}>
              <Text className="unused-free-order-main-card__use-button-text">立即使用</Text>
            </Button>
            <View className="unused-free-order-main-card__badge">
              <Text className="unused-free-order-main-card__badge-text">{badgeText}</Text>
            </View>
          </View>
          
          <View className="unused-free-order-main-card__expire-desc-wrapper">
            <Text x-if={!!endTimeStamp} className="unused-free-order-main-card__expire-desc-text">
              有效期：{endTimeStamp}
            </Text>
          </View>
        </View>
      </View>
      <View x-if={freeOrderInfo?.bindOrderId} className="used-free-order-main-card__container" style={{
        backgroundColor: styleConfig?.backgroundColor
    }}>
        <LinearGradient className="used-free-order-main-card__background" start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} colors={[styleConfig?.cardStartColor, styleConfig?.cardEndColor]}/>
        <View className="used-free-order-main-card__wrapper">
          
          <View className="used-free-order-main-card__info-row">
            <Text className="used-free-order-main-card__title" numberOfLines={2}>
              {`免单${bindBizName}：${freeOrderInfo?.bindName}`}
            </Text>
            <View className="used-free-order-main-card__amount-wrapper">
              <Text className="used-free-order-main-card__amount-label">可返现</Text>
              <Text className="used-free-order-main-card__amount-prefix" style={{
        fontFamily: priceFontFamily
    }}>
                ¥
              </Text>
              <Text className="used-free-order-main-card__amount-content" style={{
        fontFamily: priceFontFamily
    }} numberOfLines={1}>
                {yuanPrice}
              </Text>
            </View>
          </View>
          
          {(() => {
        const milestones = freeOrderInfo?.milestones ?? [];
        const lastArrivedIndex = milestones.reduce((acc, m, i) => m.hasArrived ? i : acc, -1);
        return <View className="used-free-order-main-card__milestone-row">
                
                <View className="used-free-order-main-card__milestone-track"/>
                
                {lastArrivedIndex > 0 && <View className="used-free-order-main-card__milestone-track--arrived" 
        // 黄色段宽度 = 已到达比例 × 灰色轨道宽度（75% of milestone-row）
        // 灰色轨道 left:12.5% right:12.5%，宽度占 75%
        style={{
            width: `${lastArrivedIndex / (milestones.length - 1) * 75}%`
        }}/>}
                {milestones.map((milestone, index) => {
            const isCurrent = index === lastArrivedIndex;
            return <View key={index} className="used-free-order-main-card__milestone-item">
                      
                      {milestone.hasArrived ? <Image className="used-free-order-main-card__milestone-dot--arrived" source={{
                uri: 'https://img.meituan.net/makerjiulv/6c4fdb46339ea576700a5d7ab172ecb51426.png'
            }}/> : <View className="used-free-order-main-card__milestone-dot--pending">
                          <View className="used-free-order-main-card__milestone-dot--pending-dot"/>
                        </View>}
                      
                      <Text className={isCurrent ? 'used-free-order-main-card__milestone-label--current' : 'used-free-order-main-card__milestone-label'}>
                        {MilestoneStatusText[milestone.status] ?? ''}
                      </Text>
                      
                      {!!milestone.time && !!milestone.hasArrived && <Text className="used-free-order-main-card__milestone-time">
                          {formatTimestamp(milestone.time)}
                        </Text>}
                    </View>;
        })}
              </View>;
    })()}
        </View>
      </View>
    </>;
}
export default memo(FreeOrderMainCard);
